import { NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { PQRQuadroFuncionariosRemuneracaoDto } from '../../dtos/';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { MaskitoDirective } from '@maskito/angular';
import { maskitoTransform} from '@maskito/core'
import { mask_dinheiro } from '../../directives/mascaras';

@Component({
  selector: 'app-dialog-padrao-quadro-funcionarios',
  standalone: true,
  imports: [
    NgFor,
    MatCheckbox,
    MatButtonModule,
    MatDialogModule,
    TabelaComponent,
    MaskitoDirective,
  ],
  templateUrl: './dialog-padrao-quadro-funcionarios.component.html',
  styleUrl: './dialog-padrao-quadro-funcionarios.component.scss',
})
export class DialogPadraoQuadroFuncionariosComponent {
  @Input() pqrQuadroFuncionariosRemuneracaoPadrao: PQRQuadroFuncionariosRemuneracaoDto[] = [];

  mask_dinheiro = mask_dinheiro;

  public aplicarMaskDinheiro(value: number): string {
    return maskitoTransform(String(value), mask_dinheiro);
  }
}
